export const SLICES = {
  AUTHENTICATION: 'authentication',
  PAYMENT: 'payment',
  CLAIMS: 'claims',
  VET_DETAILS: 'vetDetails',
  PET_DETAILS: 'petDetails',
  KONTENT_AI: 'kontentAi',
  DASHBOARD: 'dashboard',
  RENEWAL_HUB: 'renewalHub',
  ADJUSTED_SUMMARY: 'adjustedSummary'
};
